<template>
  <material-card
    color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          v-bind="{ title: getTitle(), text: getText() }"
          :key="componentKey"
          color="dover-blue">
          <v-container
            fill-height
            fluid
            grid-list-xl>
            <v-layout
              row
              wrap>
              <v-flex
                xs6
                md4
                lg3>
                <span
                  class="dover-blue-color">
                  {{ $t('Last measure: {0}', [currentDate]).toUpperCase() }}
                </span>
              </v-flex>
              <v-flex
                xs6
                md5
                lg5
                text-xs-center>
                <span
                  class="dover-blue-color">
                  {{ $t('Status: {0}', [status]).toUpperCase() }}
                </span>
              </v-flex>
              <v-flex
                xs12
                md3
                lg3
                text-xs-center>
                <v-btn
                  v-if="lld.lastAlarm.ackStatus === 1"
                  depressed
                  small
                  color="primary"
                  @click="onAckLldStatus">
                  {{ $t('Ack is required') }}
                </v-btn>
                <span
                  v-else
                  class="dover-blue-color">
                  {{ ackStatus }}
                </span>
              </v-flex>
              <v-flex
                xs12
                md12
                lg12>
                <hr>
              </v-flex>
            </v-layout>
          </v-container>
          <div>
            <v-flex
              xs12
              md12>
              <v-tabs
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  ripple>
                  {{ $t('Status') }}
                  <v-icon>mdi-pipe</v-icon>
                </v-tab>
                <v-tab-item
                  :key="0">
                  <MaglinkLineLeakStatusDetail
                    :lld="lld"
                    :lld-test-status="lldTestStatus"
                    :system-settings="systemSettings"
                    :options="options" />
                </v-tab-item>
                <v-tab
                  v-if="Maglink.IsAdminUser()"
                  :key="1"
                  ripple>
                  {{ $t('Diagnostic') }}
                  <v-icon>mdi-pipe-leak</v-icon>
                </v-tab>
                <v-tab-item
                  v-if="Maglink.IsAdminUser()"
                  :key="1">
                  <MaglinkLineLeakDiagnosticDetail
                    :lld-test-status="lldTestStatus"
                    :system-settings="systemSettings"
                    :options="options" />
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </div>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  props: {
    lld: {
      type: Object,
      required: false,
      default: () => {}
    },
    testStatuses: {
      type: Object,
      required: false,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    lldTestStatus: undefined
  }),
  computed: {
    ackStatus () {
      if (this.lld.lastAlarm.ackStatus === 0) return i18n.t('No alarm').toUpperCase()
      else if (this.lld.lastAlarm.ackStatus === 1) return i18n.t('Alarm is active').toUpperCase()
      else if (this.lld.lastAlarm.ackStatus === 2) return i18n.t('Alarm is acknowledged').toUpperCase()
    },
    currentDate () {
      return this.validateValue(this.Maglink.GetCustomDateTime(this.lld.lastMeasurement.measuredOn, this.systemSettings.dateFormat))
    },
    status () {
      return this.Maglink.GetStatusInfo(this.lld.lastAlarm.lldStatus).statusDesc
    }
  },
  watch: {
    testStatuses: {
      handler: function (newTestStatuses, oldTestStatuses) {
        if (newTestStatuses !== undefined && this.lld !== undefined) {
          this.lldTestStatus = newTestStatuses.find(s => s.lldNumber === this.lld.lldNumber)
        }
      },
      immediate: true
    }
  },
  methods: {
    getText () {
      return ''
    },
    getTitle () {
      if (this.lld === undefined) {
        return ''
      }

      return this.lld.lldDescription
    },
    onAckLldStatus () {
      this.$emit('ackLldStatus', this.lld.lldNumber)
    },
    validateValue (value) {
      if ((this.lld.lastMeasurement.lineStatus & 32) === 32) return '--'

      return value
    },
    snack (color, message) {
      message = this.$t('LLD Status') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
